import Helpers from './Helpers.js'
import LoggedInUser from './LoggedInUser.js'

class Message {
    constructor(params) {
        Object.keys(params).forEach(function(attr) {
            this[attr] = params[attr];
        }.bind(this));
    }


}

export default Message;
